export const sanitizeHtml = {
  beforeMount(el, binding) {
    sanitize(el, binding.value);
  },
  updated(el, binding) {
    sanitize(el, binding.value);
  },
};

function sanitize(el, html) {
  if (!html) return;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const scripts = doc.querySelectorAll('script');
  scripts.forEach(script => script.remove());

  const links = doc.querySelectorAll('a');
  links.forEach(link => {
    if (link.hasAttribute('href')) {
      let href = link.getAttribute('href');

      // If it doesn't start with http/https/mailto/tel/# and is not an internal path (/), add http://
      if (href && !href.match(/^(https?:\/\/|mailto:|tel:|#|\/)/)) {
        href = 'http://' + href;
        link.setAttribute('href', href);
      }
    }

    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
    link.removeAttribute('onclick');
    link.style.textDecoration = 'underline';
  });

  el.innerHTML = doc.body.innerHTML;
}
